/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { WebResource } from '../models/web-resource';

/**
 * Web Resource Rest Controller
 */
@Injectable({
  providedIn: 'root',
})
class WebResourceRestControllerService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `WebResourceRestControllerService.FindOneUsingGET3Params` containing the following parameters:
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  findOneUsingGET3Response(params: WebResourceRestControllerService.FindOneUsingGET3Params): __Observable<__StrictHttpResponse<WebResource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebResource>;
      })
    );
  }
  /**
   * @param params The `WebResourceRestControllerService.FindOneUsingGET3Params` containing the following parameters:
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  findOneUsingGET3(params: WebResourceRestControllerService.FindOneUsingGET3Params): __Observable<WebResource> {
    return this.findOneUsingGET3Response(params).pipe(
      __map(_r => _r.body as WebResource)
    );
  }

  /**
   * @param params The `WebResourceRestControllerService.SaveUsingPOST2Params` containing the following parameters:
   *
   * - `item`: item
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  saveUsingPOST2Response(params: WebResourceRestControllerService.SaveUsingPOST2Params): __Observable<__StrictHttpResponse<WebResource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.item;
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebResource>;
      })
    );
  }
  /**
   * @param params The `WebResourceRestControllerService.SaveUsingPOST2Params` containing the following parameters:
   *
   * - `item`: item
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  saveUsingPOST2(params: WebResourceRestControllerService.SaveUsingPOST2Params): __Observable<WebResource> {
    return this.saveUsingPOST2Response(params).pipe(
      __map(_r => _r.body as WebResource)
    );
  }

  /**
   * @param params The `WebResourceRestControllerService.GetResourcesUsingGET2Params` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  getResourcesUsingGET2Response(params: WebResourceRestControllerService.GetResourcesUsingGET2Params): __Observable<__StrictHttpResponse<Array<WebResource>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource/all`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WebResource>>;
      })
    );
  }
  /**
   * @param params The `WebResourceRestControllerService.GetResourcesUsingGET2Params` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  getResourcesUsingGET2(params: WebResourceRestControllerService.GetResourcesUsingGET2Params): __Observable<Array<WebResource>> {
    return this.getResourcesUsingGET2Response(params).pipe(
      __map(_r => _r.body as Array<WebResource>)
    );
  }

  /**
   * @param params The `WebResourceRestControllerService.SavePreferencesUsingPOST2Params` containing the following parameters:
   *
   * - `item`: item
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  savePreferencesUsingPOST2Response(params: WebResourceRestControllerService.SavePreferencesUsingPOST2Params): __Observable<__StrictHttpResponse<WebResource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.item;
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource/preferences`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WebResource>;
      })
    );
  }
  /**
   * @param params The `WebResourceRestControllerService.SavePreferencesUsingPOST2Params` containing the following parameters:
   *
   * - `item`: item
   *
   * - `filePath`: filePath
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * @return OK
   */
  savePreferencesUsingPOST2(params: WebResourceRestControllerService.SavePreferencesUsingPOST2Params): __Observable<WebResource> {
    return this.savePreferencesUsingPOST2Response(params).pipe(
      __map(_r => _r.body as WebResource)
    );
  }
}

module WebResourceRestControllerService {

  /**
   * Parameters for findOneUsingGET3
   */
  export interface FindOneUsingGET3Params {

    /**
     * filePath
     */
    filePath: string;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;
  }

  /**
   * Parameters for saveUsingPOST2
   */
  export interface SaveUsingPOST2Params {

    /**
     * item
     */
    item: WebResource;

    /**
     * filePath
     */
    filePath: string;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;
  }

  /**
   * Parameters for getResourcesUsingGET2
   */
  export interface GetResourcesUsingGET2Params {

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;
  }

  /**
   * Parameters for savePreferencesUsingPOST2
   */
  export interface SavePreferencesUsingPOST2Params {

    /**
     * item
     */
    item: WebResource;

    /**
     * filePath
     */
    filePath: string;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;
  }
}

export { WebResourceRestControllerService }
